import { useContext } from 'react';
import {
  ApiFilterOperation,
  DictionaryEvidence,
  TableCells,
  TableColumn,
  TableFilterCells,
  useStaticListSource,
} from '@eas/common-web';
import { StaticDataContext } from '@components/evidence/static-data-provider';
import { DictMonetaryCurrency } from '@models';

export function useColumns(): TableColumn<DictMonetaryCurrency>[] {
  const { currencyTags } = useContext(StaticDataContext);
  const { dictionaryColumns } =
    DictionaryEvidence.useDictionaryColumns<DictMonetaryCurrency>();

  const useTags = () => useStaticListSource(currencyTags);

  return [
    {
      datakey: 'symbol',
      name: 'Symbol',
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    {
      datakey: 'tag',
      filterkey: 'tag.id',
      sortkey: 'tag.name',
      name: 'Tag',
      width: 150,
      CellComponent: TableCells.TextCell,
      valueMapper: TableCells.useSelectCellFactory(useTags),
      FilterComponent: TableFilterCells.useFilterSelectCellFactory(useTags),
      filterOperation: ApiFilterOperation.EQ,
      sortable: true,
      filterable: true,
      filterGroup: 1,
    },
    ...dictionaryColumns.map((c) => ({ ...c, filterGroup: 2 })),
  ];
}
